import CountUp from "react-countup";
import { TrendingUp } from "lucide-react";

export default function StatCard({
  title,
  value,
  icon: Icon,
  color,
  increase = "+12%",
}) {
  return (
    <div className="relative overflow-hidden bg-white rounded-3xl border border-gray-100 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 p-6">

      {/* Background Decoration */}
      <div className="absolute -right-8 -top-8 w-28 h-28 rounded-full bg-gray-100 opacity-40"></div>

      <div className="flex justify-between items-start">

        <div>

          <p className="text-gray-500 font-medium">
            {title}
          </p>

          <h2 className="text-4xl font-bold text-gray-800 mt-4">
            <CountUp end={value} duration={2} />
          </h2>

          <div className="flex items-center mt-5 text-green-600">

            <TrendingUp size={18} />

            <span className="ml-2 font-semibold">
              {increase}
            </span>

            <span className="ml-2 text-gray-400 text-sm">
              this month
            </span>

          </div>

        </div>

        <div
          className={`w-16 h-16 rounded-2xl flex items-center justify-center ${color}`}
        >
          <Icon size={30} className="text-white" />
        </div>

      </div>

      {/* Progress */}

      <div className="mt-6">

        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">

          <div
            className={`${color} h-2 rounded-full`}
            style={{ width: "75%" }}
          ></div>

        </div>

      </div>

    </div>
  );
}